<template>
    <div class="theLaw-div">
        <div class="theLaw-head">
            考试报名系统
        </div>
        <div class="theLaw-content" v-if="name=='举报不良信息'">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="姓名:">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号:">
                    <el-input v-model="form.phone" type="phone"></el-input>
                </el-form-item>
                <el-form-item label="举报标题:">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="举报内容:">
                    <el-input type="textarea" v-model="form.content"></el-input>
                </el-form-item>
                <el-button type="primary" @click="onSubmit">提交</el-button>
            </el-form>
        </div>
        <div v-else class="content1">
            <ul v-if="name == '隐私政策声明'">
                <li class="title-top">中国国际工程咨询协会网站隐私条款</li>
                <li class="suojin">以下是本网站（www. caiec.org.cn）及其运营主体中国国际工程咨询协会（以下合称"本网站"）的隐私规则。用户成为本网站用户前务必仔细阅读本隐私规则并同意本隐私规则。作为本网站服务的正常操作程序的一部分，本网站收集、使用并（在一些情况下）向第三方披露有关用户的资料。本隐私规则作为本网站服务协议的附件，在用户注册成为本网站用户后立即生效，并对用户及本网站产生约束力。</li>  
                <li class="title-top">涉及的个人资料</li>
                <li class="suojin">本网站能在匿名的状态下访问我们的网站并获取信息。在我们请求您提供有关信息之前，我们会解释这些信息的用途我们有些站点需要注册才能加入。本网站按照用户在本网站网址上的行为自动追踪关于用户的某些资料。本网站利用这些资料进行有关本网站之用户的人口统计、兴趣及行为的内部研究，以更好地了解用户以便向用户和本网站的用户社区提供更好的服务。本网站在本网站的某些网页上使用诸如"Cookies"的资料收集装置。"Cookies"是设置在用户的硬盘上的小档案，以协助本网站为用户提供度身订造的服务。本网站亦提供某些只能通过使用"Cookies"才可得到的功能。本网站还利用"Cookies"使用户能够在某段期间内减少输入密码的次数。"Cookies"还可以协助本网站提供专门针对用户的兴趣而提供的资料。</li>
                <li class="title-top">本网站对用户的资料的使用</li>
                <li class="suojin">用户同意本网站可使用关于用户的个人资料（包括但不限于本网站持有的有关用户的档案中的资料，及本网站从用户目前及以前在本网站上的活动所获取的其他资料）以解决争议、对纠纷进行调停、有助于确保在本网站进行安全的交易，并执行本网站的用户协议。本网站有时候可能调查多个用户以识别问题或解决争议，特别是本网站可能审查用户的资料以区分使用多个用户名或别名的用户。 为限制在网站上的欺诈、非法或其他刑事犯罪活动，使本网站免受其害，用户自愿同意本网站可通过人工或自动程序对用户的个人资料进核实。</li>
                <li class="title-top">本网站对用户的资料的披露</li>
                <li class="suojin">本网站将采用行业标准惯例以保护用户的个人资料，但鉴于技术限制，本网站不能确保用户的全部私人通讯及其他个人资料不会通过本隐私规则中未列明的途径泄露出去。本网站有义务根据有关法律要求向司法机关和政府部门提供用户的个人资料。</li>
                <li class="title-top">用户对其他用户的资料的使用</li>
                <li class="suojin">在本网站提供的交易活动中，用户无权要求本网站提供其他用户的个人资料。</li>
                <li class="title-top">电子邮件</li>
                <li class="suojin">用户不得使用本网站提供的服务或其他电子邮件转发服务发出垃圾邮件或其他可能违反中华人民共和国法律和法规、社会道德及本网站的用户协议或隐私规则的内容。本网站除了利用该电子邮件地址发出用户的电子邮件之外将不作任何其他用途。本网站不会出租或出售这些电子邮件地址。本网站不会永久储存电子邮件信息或电子邮件地址。</li>
                <li class="title-top">账户信息的安全性</li>
                <li class="suojin">用户必须对用户本人在本网站使用的用户名、密码、注册电子邮箱及其他安全设置所采取的一切行为负责，因此，本网站没有义务保管用户的注册资料。</li>
                <li class="title-top">规则修改</li>
                <li class="suojin">本网站可能不时按照用户的意见和本网站的需要修改本隐私规则，以准确地反映本网站的资料收集及披露惯例。</li>
            </ul>
            <ul v-else-if="name == '法律声明'">
                <li class="title-top">法律声明</li>
                <li class="suojin">本网站由中国国际工程咨询协会（以下简称"协会"）创建并运行维护。任何人进入本网站、阅读任何内容、进行用户注册、从本网站下载任何材料或使用本网站提供的资料，即表示同意遵守下列条款。这些条款构成协会与您之间的协议。若不同意遵守这些条款，切勿使用本网站。协会保留未经通知随时更新下列条款的权利，这些更新将同样也约束您。任何时间，任何情况下，协会均有权拒绝任何用户进入、使用本网站。</li>  
                <li class="suojin">协会保留随时更正、修改、更新本声明的权利。</li>
                <li class="title-top">版权声明</li>
                <li class="suojin">协会独立拥有本网站相关网页内所有资料的版权，或与本网站相关网页内的资料提供者共同拥有该网页内资料的版权。未经协会的明确书面许可，对于本网站上的任何内容，任何人不得对其进行复制或在非协会所属的服务器上做镜像。</li>
                <li class="suojin">本网站所载述的域名、商标、文字、视像及声音内容、图形及图像均受有关商标和著作权的法律保护。未经协会事先以书面明确的允许，任何企业或个人不得以任何形式复制或传递。任何未经授权使用本网站的行为都将违反《中华人民共和国著作权法》和其他相关法律法规以及有关国际公约的规定。</li>
                <li class="title-top">免责条款</li>
                <li class="suojin">对本网站的内容，我们不提供任何形式的明示的或默示的关于内容的正确性、及时性、有效性、稳定性、可用性、不侵犯他人权利等方面的保证；不保证服务器的稳定性，不保证您任何时候均可浏览、阅读、复制、使用本网站；不保证网站内容所包含的文字、图形、材料、链接、说明、陈述或其它事项的准确性或完整性，也不保证本网站的内容不存在打印、复制及其他输入方面的错误。协会可随时更改本网站内容，无须另作通知。</li>
                <li class="suojin">用户使用本网站服务所存在的风险将和产生的一切后果由其自己承担。在任何情况下，对于因使用本网站内容或无法进入本网站而导致的任何直接的、间接的、附带的、给第三人造成的损失(包括但不限于利润损失、信息数据丢失、财产毁坏等损失)，本网站都无须承担任何法律责任。</li>
                <li class="title-top">协会对本网站和其内容的不能使用和使用错误不承担任何责任</li>
                <li class="suojin">任何情况下，协会及相关人对于进入或使用本网站引起的任何依赖本网站内容而做出的决定或采取的行动不承担任何责任，对进入或使用本网站而产生的任何直接的、间接的、惩罚性的损失，或其他任何形式的损失包括但不限于业务中断、数据丢失或利润损失不承担任何责任。</li>
                <li class="suojin">本网站转载的相关文章、资料中表述或暗示的观点不代表协会的观点。对于本网站所转载的信息如有著作权争议，请与我们联系并提供相应的证明资料。</li>
                <li class="suojin">网站上所展示的第三方网站的链接并不构成我们对该第三方网站的保证，我们对于这些网站及其内容的有效性不负有责任。访问这些网站的超链接的风险由用户承担。</li>
                <li class="suojin">协会以及相关人对于第三人采用非法手段进入本网站取得有关密码、资料和内容而引起的任何直接及间接损害或损失不承担任何责任。</li>
                <li class="title-top">保护用户隐私权</li>
                <li class="suojin">我们尊重广大用户的隐私，未经用户的同意，我们不搜集用户的资料。对于因服务的需要而掌握的用户名、电子邮件、信息和地址等我们承诺非经用户允许，不向任何第三方出售或提供。</li>
                <li class="suojin">协会不会公布或传播用户在本网站注册的任何资料，但下列情况除外：</li>
                <li class="suojin">1. 事先获得用户的明确授权；</li>
                <li class="suojin">2. 依据法院、仲裁机构的裁判或裁决，以及其他司法程序的要求；</li>
                <li class="suojin">3. 按照相关政府主管部门的要求；</li>
                <li class="suojin">4. 用户违反使用条款的规定或有其他损害协会利益的行为；</li>
                <li class="suojin">5. 其他有关法律法规的要求。</li>
                <li class="suojin">用户如希望使用本网站需注册后才能够提供的服务，应同意以下事项：依本网站服务注册表之提示提供您本人真实、正确、最新及完整的资料，并随时更新登记资料，确保其为真实、正确、最新及完整的资料。若您提供任何错误、不实、过时或不完整或具误导性的资料，或者本网站有理由怀疑前述资料为错误、不实、过时或不完整或具误导性的，本网站有权暂停或终止您的帐号，并拒绝您于现在和未来使用本网站所提供服务之全部或任何部分。</li>
                <li class="title-top">商标与域名声明</li>
                <li class="suojin">协会网站（www. caiec.org.cn）使用的所有协会图案及文字商标均为协会在中国和/或其他国家的注册商标或商标，未经协会书面授权，任何单位或个人不得以任何方式使用上述商标。</li>
                <li class="suojin">www. caiec.org.cn的域名为协会所有。未经协会书面授权，任何单位或个人不得使用。</li>
                <li class="title-top">指向本网站的链接</li>
                <li class="suojin">如希望作指向到本网站的链接，请联络我们；在获得协会的书面许可后，方可链接本网站。</li>
                <li class="suojin">在建立链接后，如协会根据客观情况认为不再合适链接时，有权取消对链接的许可。</li>
                <li class="suojin">在链接到本网站时，请务必使用文本链接（如无协会的书面许可，禁止使用协会图案及文字的链接方式）；点击本网站链接要设定成另开窗口显示的形式，不能显示在链接方网站的框架内部。</li>
                <li class="title-top">其他网站的链接</li>
                <li class="suojin">本网站中所链接的协会以外的网站，不在协会的管理之下。对因通过协会网站访问其他链接网站而发生的任何损害，协会不承担任何责任。访问链接网站时，请遵循其链接网站的使用条款及相关法律法规的规定。</li>
                <li class="suojin">协会仅为方便访问而提供他方网站的链接，并非是对链接网站的使用及其登载商品/服务等进行推举，并不意味着协会与所链接网站的公司、个人之间有着联合、协作等特殊关系，也并不表示协会认可或承担其他网站内容或使用上的责任。</li>
                <li class="title-top">本站下载资源的使用</li>
                <li class="suojin">任何人在进入、使用、浏览协会网站时，感染病毒，协会不承担任何责任。通过协会链接到第三方网站而感染病毒的，协会不承担任何责任。</li>
                <li class="title-top">终止条款</li>
                <li class="suojin">无论是否在此协议所规定的条款下或其他情况下，只要你将所有的从本网站获得的软件、文件和一切相关材料销毁，即构成本协议的终止。</li>
                <li class="title-top">法律适用和管辖</li>
                <li class="suojin">任何有关本网站和网站声明的争议、纠纷，均适用中华人民共和国法律。任何有关本网站和网站声明的争议，应由协会所在地的人民法院管辖。如中华人民共和国法律的修改使上述任何条款成为非法，各方将同意由协会对上述条款做出修改。</li>
                <li class="suojin">本声明的解释权及对本网站使用的解释权归结于协会所有。</li>
            </ul>
            <ul v-else-if="name == '可接受的使用政策'">
                <li class="title-top">可接受的使用政策</li>
                <li class="suojin">可接受的使用政策建立在我们和您链接到我们的网站的情况下[http:// www. caiec.org.cn/]。这可接受的使用政策适用于所有的我们网站的用户和访客。</li>  
                <li class="suojin">使用我们的站点意味着您接受并同意遵守,所有我们的网站补充的可接受的使用政策。</li>
                <li class="title-top">禁止使用</li>
                <li class="suojin">您只能将我们的网站用于合法目的使用。</li>
                <li class="title-top">您不能将我们的网站用作以下目的：</li>
                <li class="suojin">伤害或试图伤害未成年人</li>
                <li class="suojin">任何方式的非法或诈欺，或达到非法或诈欺的目的或效果。</li>
                <li class="suojin">发送、故意接收、上传、下载、使用或重用任何不符合我们的内容标准的材料</li>
                <li class="suojin">传输、发送任何未经请求或未经授权或任何其他形式的广告或促销材料类的材料</li>
                <li class="suojin">故意传播数据、发送或上传任何材料包含病毒、特洛伊木马、蠕虫、定时炸弹,击键记录者,间谍软件,广告软件或任何其他有害程序或类似的计算机代码旨在影响任何计算机软件或硬件的操作。</li>
                <li class="title-top">同时您同意：</li>
                <li class="suojin">不以任何违反我们的网站使用条款的规定来复制、再出售或推销我们的网站。</li>
                <li class="suojin">不在未经授权的情况下访问、干扰、损坏或破坏；</li>
                <li class="suojin">网站的任何部分；</li>
                <li class="suojin">网站上储存的设备或网络；</li>
                <li class="suojin">网站上使用的任何软件；</li>
                <li class="suojin">第三方在网站上储存或使用的设备或网络。</li>
                <li class="title-top">交互式服务</li>
                <li class="suojin">我们可能不时地会在网站上提供交互式服务（"交互式服务"）。我们将提供明确的信息给你提供什么样的交互式服务，如以适度使用的形式（其中包括人和技术的问题）。</li>
                <li class="suojin">我们将尽最大努力为用户评估从第三方时使用我们网站上提供任何互动服务存在的任何可能的风险(特别是儿童)。我们将在每种情况下决定是否使用适量的相关服务(包括如何适度使用)的这些风险。然而，我们没有监督、监控或调解任何我们网站上内容的义务。我们对于用户违反我们的内容标准而引起的任何损失或损害，皆不负任何责任。</li>
                <li class="suojin">未成年人使用我们任何的互动服务都需要得到他们的父母或监护人的同意。对于允许孩子使用互动服务的家长，我们建议他们与他们的孩子做好关于网络安全的适当沟通。未成年人应意识到使用任何互动服务存在的潜在风险。</li>
                <li class="titler-top">内容标准</li>
                <li class="suojin">这些内容标准适用于所有由您对我们网站的贡献和任何与之相关的交互式服务的材料。</li>
                <li class="suojin">您必须符合以下文字所表达的精神。无论部分还是整体的贡献，它的标准都适用。</li>
                <li class="titler-top">必须：</li>
                <li class="suojin">精准</li>
                <li class="suojin">真正地实行</li>
                <li class="suojin">遵守在中国和任何国家都适用的法律</li>
                <li class="titler-top">不能：</li>
                <li class="suojin">包含任何诽谤任何人的材料。</li>
                <li class="suojin">包含任何淫秽、具有攻击性、有害或煽动性的材料</li>
                <li class="suojin">宣扬色情的材料。</li>
                <li class="suojin">宣扬暴力。</li>
                <li class="suojin">宣扬针对种族、性别、宗教、国籍、残疾、性取向和年龄的歧视。</li>
                <li class="suojin">侵犯任何其他人的版权、资料库权或商标权。</li>
                <li class="suojin">可能欺骗他人。</li>
                <li class="suojin">违反法律义务，如先契约义务忠实和保密义务。</li>
                <li class="suojin">宣扬非法活动。</li>
                <li class="suojin">威胁、滥用或侵犯他人的隐私或对造成不便或不必要的麻烦。</li>
                <li class="suojin">对他人造成骚扰，难堪或惊恐的行为。</li>
                <li class="suojin">被用来假冒他人或歪曲您的身份来和其他人联系。</li>
                <li class="suojin">给予他人冒充是我们的错觉。</li>
                <li class="suojin">倡导、促进或协助任何违法行为如侵犯版权或滥用电脑。</li>
                <li class="titler-top">中止终结</li>
                <li class="suojin">我们将自行考虑和判断是否您在使用网站的过程中违反我们的可使用政策。当有违反政策的行为发生时，我们可能会采取我们认为合适的行动。</li>
                <li class="suojin">在您被允许使用我们网站的过程中，如您未能遵守可使用政策并构成重大违约的情况下，我们可能会采取下列全部或任何行动：</li>
                <li class="suojin">立即、暂时或永久禁止您使用我们的网站</li>
                <li class="suojin">直接、间接或永久删除任何您发表或上传至我们网站的材料</li>
                <li class="suojin">对您进行警告</li>
                <li class="suojin">在造成赔偿的基础上对您提起诉讼</li>
                <li class="suojin">对您采取进一步的法律行动</li>
                <li class="suojin">如有必要，我们会将此类信息披露给相关执法部门</li>
                <li class="suojin">如违反本可接受的使用政策，我们将排除责任。除了上述我们列举的行动，我们可能会采取任何其他我们认为合适的行动。</li>
                <li class="titler-top">对可接受的使用政策的改变</li>
                <li class="suojin">我们可能在任何时候通过修改此页面的内容来修改下列的可接受的使用政策。您可以通过查看此页面的内容来了解我们的任何变化，因此这些变化具有法律约束力。包含在这个可接受的使用政策中的一些规定可能取代发布在我们网站上的条款或通知。</li>
            </ul>
        </div>
        <ul class="falv">
            <router-link tag="li" :to="{path:'theLaw',query:{name:'法律声明'}}" @click.native="ceshi('法律声明')"><span>法律声明</span></router-link>
            <router-link tag="li" :to="{path:'theLaw',query:{name:'隐私政策声明'}}" @click.native="ceshi('隐私政策声明')"><span>隐私政策声明</span></router-link>
            <router-link tag="li" :to="{path:'theLaw',query:{name:'举报不良信息'}}" @click.native="ceshi('举报不良信息')"><span>举报不良信息</span></router-link>
            <router-link tag="li" :to="{path:'theLaw',query:{name:'可接受的使用政策'}}" @click.native="ceshi('可接受的使用政策')"><span>可接受的使用政策</span></router-link>
        </ul>
    </div>
</template>
<script>
import apiHttp from '../api/index.js'
export default {
    data(){
        return{
            name:this.$route.query.name,
            form: {
                name: '',
                phone:'',
                title:'',
                content:''
            }
        }
    },
    mounted(){
        
    },
    methods:{
        ceshi(name){
            this.name = name
        },
        onSubmit(){
            if(this.form.name && this.form.phone && this.form.title && this.form.content){
                apiHttp.apiIndex.infoComplaint(this.form).then(resp=>{
                    if(resp.code == 0){
                        this.$confirm('举报成功', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            content:true
                        }).then(() => {
                            this.$router.push({
                                name:'login'
                            })
                        }).catch(() => {
                        
                        });
                    }
                })
            }else{
                this.$message({
                    message: '您填写的信息不完整，请仔细检查',
                    type: 'warning'
                });
            }
        }
    },
}
</script>

<style lang="less" scoped>
.theLaw-div{
    width: 100%;
    height: 100%;
    .theLaw-head{
        height: 100px;
        width: 100%;
        font-size: 30px;
        color: #fff;
        font-weight: bold;
        background-color: #5d2805;
        text-align: left;
        line-height: 100px;
        padding-left: 30px;
    }
    .content1{
        text-align: left;
        width: 90%;
        margin: 0 auto;
        overflow-y:scroll;
        height: 100%;
        ul{
            width: 100%;
            height: 100%;
            padding-bottom: 100px;
            li{
                line-height: 30px;
            }
            .suojin{
                text-indent:35px;
            }
            .title-top{
                padding-top: 20px;
            }
        }
    }
    .theLaw-content{
        width: 380px;
        margin: 40px auto;
        padding: 30px;
        border:solid 1px #ccc;
        border-radius: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/theLaw.vue